import { Uuid } from "@/domains/global/identifiers";
import { api } from "@/modules/api";

type TriggerNoteReminderShillPost = (
  path: "/v2/notes/{note_id}/reminder-shill/trigger",
  options: {
    params: {
      path: {
        note_id: Uuid;
      };
    };
    body: {
      reminder_shill_id: Uuid;
      generated_reminder_text: string;
    };
  }
) => Promise<{
  response: {
    ok: boolean;
  };
  error?: {
    error_message?: string;
  };
}>;

/**
 * Triggers backend Mem Agent reminder work for an existing owner-visible reminder shill.
 */
export async function triggerNoteReminderShill({
  noteId,
  reminderShillId,
  generatedReminderText,
}: {
  noteId: Uuid;
  reminderShillId: Uuid;
  generatedReminderText: string;
}) {
  const postTrigger = api.post as unknown as TriggerNoteReminderShillPost;
  const response = await postTrigger("/v2/notes/{note_id}/reminder-shill/trigger", {
    params: {
      path: {
        note_id: noteId,
      },
    },
    body: {
      reminder_shill_id: reminderShillId,
      generated_reminder_text: generatedReminderText,
    },
  });

  if (!response.response.ok) {
    throw new Error(response.error?.error_message ?? "Failed to create reminder.");
  }
}
